import DOMPurify from "dompurify";

/**
 * Sanitize untrusted CMS HTML before it is injected into the DOM.
 * CMS content is admin-authored, but a compromised/insider account or an
 * imported page could still carry script payloads — DOMPurify strips them.
 */
export function sanitizeHtml(dirty: string): string {
  if (!dirty) return "";
  return DOMPurify.sanitize(String(dirty));
}